import { CategoryEndpoints } from '@/modules/inventory/category/api/categoryEndpoints'

export const categoryEndpoint = new CategoryEndpoints('category')
